$=jQuery;
function addLoadEvent(func) {
    var oldonload = window.onload;
    if (typeof window.onload != 'function') {
        window.onload = func;
    } else {
        window.onload = function () {
            oldonload();
            func();
        };
    }
}

import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import Swiper from 'swiper';
import {Navigation,Pagination,Autoplay,} from 'swiper/modules';
import "splitting/dist/splitting.css";
import "splitting/dist/splitting-cells.css";
import Splitting from "splitting";
import Lenis from 'lenis'



gsap.registerPlugin(ScrollTrigger);

jQuery(function ($) {


    // --- SHOWHIDE NAVBAR ---

    var didScroll;
    var lastScrollTop = 0;
    var delta = 120;
    var navbarHeight = 110;
    $(window).scroll(function () {
        didScroll = true;
    });
    setInterval(function () {
        if (didScroll) {
            hasScrolled();
            didScroll = false;
        }
    }, 350);
    function hasScrolled() {
        var st = $(this).scrollTop();
        if (Math.abs(lastScrollTop - st) <= delta)
            return;
        if (st > lastScrollTop && st > navbarHeight) {
            $('.nav-sticky').addClass('nav-up');
        } else {
            if (st + $(window).height() < $(document).height()) {
                $('.nav-sticky').removeClass('nav-up');
            }
        }
        lastScrollTop = st;
    }
    
    // --- NAV ---

    
    $(".nav-burger").click(function () {
        $(".burger").toggleClass("active");
        $(".nav-responsive").toggleClass("active");
        $("html").toggleClass("block-viewport");
        $("body").toggleClass("block-viewport");
    }); 
    
    $(".nav-active ul.menu > li.menu-item-has-children > a").on("click", function(e){
        e.preventDefault();
        e.stopPropagation();
        
        var $this = $(this);
        var $parent = $this.parents("li").first();
        
        var $subMenu = $("ul.sub-menu", $parent);
        if($subMenu.is(":visible")) {
            $subMenu.hide();
        } else {
            $(".nav-active ul.menu li ul.sub-menu").hide();
            $subMenu.show();
        } 
    });
    
    $(".page-single article .gallery br").remove();  

    // --- BURGER ANIMATED ---
    
    $('#nav-burger-animated').click(function () {
        $(this).toggleClass('open');
    });

    // --- NOTICE ALERT ---
    
    $(".notice-alert-close").click(function () {
        $(".notice-alert").slideUp();
    });
    
    $(document.body).trigger('wc_fragment_refresh');

    let titleAccueil = Splitting({ target: title__accueil, by: 'chars' });
    gsap.from(titleAccueil[0].chars,{
        color: "rgb(11,51,96)",
        duration:2,
        stagger: 0.05,
       })

    let mate= Splitting({ target: '#mate', by: 'chars' });
    
    gsap.from(mate[0].chars,{
        color: "rgb(6,33,77)",
        stagger: 0.05,
        scrollTrigger:{
            trigger: ".section__presentation", 
            scrub: true,
            start:"top 50%",
            end: "bottom bottom",
           
        }
       })

       let titleMate= Splitting({ target: '.titleMate', by: 'chars' });
      
       gsap.from(titleMate[0].chars,{
            color: "rgb(6,33,77)",
           stagger: 0.05,
           scrollTrigger:{
               trigger: ".section__presentation", 
               scrub: true,
               start:"top 50%",
               end: "bottom bottom",
            
           }
          })

        gsap.from(".section__presentation .col__content",{
        y:150,
        scrollTrigger:{
            trigger: ".section__presentation", 
            scrub: true,
            start:"top 70%",
            end: "bottom bottom"
        }
        })
     

    let selection = Splitting()

    
   gsap.from(selection[0].chars,{
    color: "rgb(255,255,255)",
    stagger: 0.5,
    scrollTrigger:{
        trigger: ".section__efficacite", 
        scrub: true,
        start:"top 50%",
        end: () => window.innerWidth <= 768 ? "top 10%" : "bottom bottom",
       
    }
   })

   // Initialize a new Lenis instance for smooth scrolling
    const lenis = new Lenis();

    // Synchronize Lenis scrolling with GSAP's ScrollTrigger plugin
    lenis.on('scroll', ScrollTrigger.update);

    // Add Lenis's requestAnimationFrame (raf) method to GSAP's ticker
    // This ensures Lenis's smooth scroll animation updates on each GSAP tick
    gsap.ticker.add((time) => {
    lenis.raf(time * 800); // Convert time from seconds to milliseconds
    });

    // Disable lag smoothing in GSAP to prevent any delay in scroll animations
    gsap.ticker.lagSmoothing(0);


    gsap.from(".grid__container",{
        y:150,
        scrollTrigger:{
            trigger: ".section__efficacite", 
            scrub: true,
            start:"top 70%",
            end: "bottom bottom"
        }
    })

    

    
});

    
    

